'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var addAll = require('./add-all.js');
var last = require('it-last');
var configure = require('../lib/configure.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var last__default = /*#__PURE__*/_interopDefaultLegacy(last);

function createAdd(config) {
  const all = addAll.createAddAll(config);
  return configure.configure(() => {
    async function add(path, options = {}) {
      return last__default['default'](all([{
          path,
          ...options
        }], options));
    }
    return add;
  })(config);
}

exports.createAdd = createAdd;
